

import Axios from 'axios';
// import { Message } from 'element-ui';

var data = {
  list: [],// init后列表
  itemDataCache: {},// init后, 以id为key的对象组
  init: function(res){// [{}]
    data.list = res || [];
    var ary = data.list;
    for(var i=0;i<ary.length;i++){
      data.itemDataCache[ary[i].code] = ary[i];
    }
  },
  submit(params, callback){
    Axios.post("/cat/api/v1/user/update", params).then((response) => {
      if (!response) {
        return
      }
      callback&&callback(response);

    }).catch((error) => {

      // Message({
      //   message: "网络出错!",
      //   type: "error"
      // });
      // console.log(error);

    });
  },
  toDataAry(ary){
    var result = [];
    if(ary){
      for(var i=0;i<ary.length;i++){
        result.push({
          langCode: data.itemDataCache[ary[i]].code,
          langName: data.itemDataCache[ary[i]].name,
        });
      }
    }
    return result;
  },
  toDataAry_un(ary){// 根据提交格式, 转成名字组
    var result = [];   
    if(ary){
      for(var i=0;i<ary.length;i++){
        result.push(ary[i].langCode);
      }
    }
    return result;
  },
  // toIdAry(ary){
  //   var result = [];
  //   if(ary){
  //     for(var i=0;i<ary.length;i++){
  //       result.push(data.itemDataCache[ary[i]].id);
  //     }
  //   }
  //   return result;
  // },
};

export default data;